import { withStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import React from "react";

export const CustomTextField = withStyles((theme) => ({
    root: {
        '& .MuiInputLabel-outlined': {
            position: 'relative',
            marginBottom: '8px',
            fontWeight: '500',
            fontSize: '1rem',
            color: (props) => props.theme?.labelColor || '#000000',
            transform: 'none',
            '&.Mui-focused': {
                color: (props) => props.theme?.labelFocusColor || '#000000',
            },
        },

        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'none',
            marginBottom: '8px',
            backgroundColor: 'transparent',
            padding: 0,
        },

        '& .MuiOutlinedInput-root': {
            backgroundColor: (props) => props.theme?.inputBg || '#ffffff',
            border: (props) => `1px solid ${props.theme?.inputBorder || '#dee2e6'}`,
            borderRadius: (props) => props.theme?.borderRadius || '4px',

            '&.Mui-focused': {
                backgroundColor: (props) => props.theme?.focusBg || props.theme?.inputBg || '#ffffff',
                borderColor: (props) => props.theme?.focusBorder || '#80bdff',
                boxShadow: (props) => props.theme?.focusShadow || '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',
                outline: 'none',
            },
            '&.Mui-error': {
                borderColor: '#d32f2f',
            },
            '&.Mui-error.Mui-focused': {
                boxShadow: '0 0 0 0.2rem rgba(211, 47, 47, 0.25)',
            },
            '&:hover': {
                borderColor: (props) => props.theme?.hoverBorder || '#80bdff',
                backgroundColor: (props) => props.theme?.hoverBg || props.theme?.inputBg,
            },
            '&.Mui-error:hover': {
                borderColor: '#d32f2f',
            },
            '& fieldset': {
                border: 'none',
            },
        },
        '& .MuiFormHelperText-root.Mui-error': {
            color: '#d32f2f',
            marginLeft: 0,
            marginTop: '4px',
        },
        '& .MuiInputBase-input': {
            padding: (props) => props.theme?.inputPadding || '0.5rem 0.75rem',
            fontSize: '1rem',
            color: (props) => props.theme?.inputColor || '#000000',
            '&::placeholder': {
                color: (props) => props.theme?.placeholderColor || '#6c757d',
                opacity: 1,
            },
        },
    },
}))((props) => {
    const { theme, ...otherProps } = props;
    return (
        <TextField
            {...otherProps}
            variant="outlined"
        />
    );
});
